import gql from 'graphql-tag';

export default gql`
query getLocalIdOfProject($projectId: Int!) {
  projects(where: {project_id: {_eq: $projectId}}) {
    language_id
  }
}
`;
